export enum RolloverExpiryDurationType {
	Month = "month",
	Forever = "forever",
}
